import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const listNotifications = async ({
    userRoleUuid,
    notificationTypes,
    notificationPriority,
    paginationToken,
    paginationLimit
} = {}) =>
    api.get('/notifications', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            ...(Array.isArray(notificationTypes) && notificationTypes.length > 0
                ? { 'CVP-QUERY-NOTIFICATION-TYPE': JSON.stringify(notificationTypes) }
                : {}),
            ...(notificationPriority
                ? { 'CVP-QUERY-NOTIFICATION-PRIORITY': notificationPriority }
                : {}),
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {}),
            ...(paginationLimit ? { 'PAGINATION-LIMIT': paginationLimit } : {})
        }
    });

export const listSeenNotifications = async ({
    userRoleUuid,
    notificationTypes,
    notificationPriority,
    paginationToken,
    paginationLimit
} = {}) =>
    api.get('/notifications/seen', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            ...(Array.isArray(notificationTypes) && notificationTypes.length > 0
                ? { 'CVP-QUERY-NOTIFICATION-TYPE': JSON.stringify(notificationTypes) }
                : {}),
            ...(notificationPriority
                ? { 'CVP-QUERY-NOTIFICATION-PRIORITY': notificationPriority }
                : {}),
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {}),
            ...(paginationLimit ? { 'PAGINATION-LIMIT': paginationLimit } : {})
        }
    });

export const markNotificationAsSeen = async ({ userRoleUuid, notificationUuid }) =>
    api.patch(
        '/notifications',
        {
            notification: notificationUuid
        },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );
